import { Nullable } from '@common/type/CommonTypes';
import { CoreApiResponse, CoreApiStatusResponse } from '@common/type/CoreApiResponseTypes';
import { ProductBrand } from '@common/type/GoogleTagType';
import { ProductAffiliation } from '@common/type/ProductType';

import { ProductPrice } from '@redux/course/type/productType';

export type FetchBundleDetailSeoRequestAction = {
  idName: string;
};

export type BundleEntity = {
  id: number;
  idName: string;
  name: string;
  description: string;
  hasCourseCPD: boolean;
};

// Bundle detail seo
export type FetchBundleDetailSeoState = BundleEntity;

export type FetchBundleDetailSeoSuccessAction = FetchBundleDetailSeoState;

export type FetchBundleDetailSeoErrorAction = unknown;

export type HttpFetchBundleDetailSeoStatusResponse = CoreApiStatusResponse;

export type HttpFetchBundleDetailSeoApiResponse = CoreApiResponse<
  FetchBundleDetailSeoSuccessAction,
  HttpFetchBundleDetailSeoStatusResponse
>;

//  Bundle detail
export type FetchBundleDetailRequestAction = {
  bundleIdOrIdName: string;
};

export enum BundleCountdownDay {
  LIFETIME = 'lifetime',
  ALL_EQUAL = 'all_equal',
  NOT_EQUAL = 'not_equal',
}

export type BundleDetailEntity = {
  price: ProductPrice;
  courseCardImageUrl: Nullable<string>;
  videoCount: number;
  totalVideoDuration: number;
  countdownDayType: BundleCountdownDay;
  countdownDay: number;
  attachmentFileCount: number;
  quizCount: number;
  articleCount: number;
  certificateCount: number;
  courseCount: number;
  productAffiliation: ProductAffiliation;
  gtmContentId: string;
  gtmProductBrand: ProductBrand;
  bannerPrimaryColor: string;
  bannerSecondaryColor: string;
};

export type FetchBundleDetailState = BundleDetailEntity;

export type FetchBundleDetailSuccessAction = FetchBundleDetailState;

export type FetchBundleDetailErrorAction = unknown;

export type HttpFetchBundleDetailStatusResponse = CoreApiStatusResponse;

export type HttpFetchBundleDetailApiResponse = CoreApiResponse<
  FetchBundleDetailSuccessAction,
  HttpFetchBundleDetailStatusResponse
>;

//  Bundle Courses
export type FetchBundleCoursesRequestAction = {
  bundleIdOrIdName: string;
};

export type BundleCourseInstructorEntity = {
  fullName: string;
  imageUrl: string;
};

export type BundleCoursesEntity = {
  id: number;
  name: string;
  idName: string;
  countdownDay: number;
  sortOrder: number;
  highlightImage1xUrl: string;
  highlightImage2xUrl: string;
  hasCertificate: boolean;
  isEnrolled: boolean;
  instructors: BundleCourseInstructorEntity[];
}[];

export type FetchBundleCoursesState = BundleCoursesEntity;

export type FetchBundleCoursesSuccessAction = FetchBundleCoursesState;

export type FetchBundleCoursesErrorAction = unknown;

export type HttpFetchBundleCoursesStatusResponse = CoreApiStatusResponse;

export type HttpFetchBundleCoursesApiResponse = CoreApiResponse<
  FetchBundleCoursesSuccessAction,
  HttpFetchBundleCoursesStatusResponse
>;

//  Bundle Enrollment
export type FetchBundleEnrollmentRequestAction = {
  bundleIdOrIdName: string;
};

export enum BundleEnrollmentStatus {
  ENROLLED = 'enrolled',
  ENROLLED_SOME_COURSE = 'enrolled_some_course',
  ENROLLED_EVERY_COURSE = 'enrolled_every_course',
  UNPUBLISHED = 'unpublished',
  PUBLISHED = 'published',
  AVAILABLE_REGISTER = 'available_register',
}

export type BundleEnrollmentEntity = {
  enrollmentStatus: BundleEnrollmentStatus;
  hasEnrolled: boolean;
};

export type FetchBundleEnrollmentState = BundleEnrollmentEntity;

export type FetchBundleEnrollmentSuccessAction = FetchBundleEnrollmentState;

export type FetchBundleEnrollmentErrorAction = unknown;

export type HttpFetchBundleEnrollmentStatusResponse = CoreApiStatusResponse;

export type HttpFetchBundleEnrollmentApiResponse = CoreApiResponse<
  FetchBundleEnrollmentSuccessAction,
  HttpFetchBundleEnrollmentStatusResponse
>;
